import { render, staticRenderFns } from "./MenuLogo.vue?vue&type=template&id=4458d783&scoped=true"
import script from "./MenuLogo.vue?vue&type=script&lang=js"
export * from "./MenuLogo.vue?vue&type=script&lang=js"
import style0 from "./MenuLogo.vue?vue&type=style&index=0&id=4458d783&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4458d783",
  null
  
)

export default component.exports